export default __webpack_public_path__ + "static/media/arrow.303a39db.svg";